module.exports = __webpack_public_path__ + "static/bootstrap-124ffa7020030778745d93b9e7ccff6b.png";